import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import SEO from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <SEO 
        title="Page Not Found | CodeRide"
        description="The page you are looking for does not exist."
        ogType="website"
        structuredData={{
          "@context": "https://schema.org",
          "@type": "WebPage",
          "@id": "https://coderide.ai/404",
          "url": "https://coderide.ai/404",
          "name": "Page Not Found | CodeRide",
          "description": "The page you are looking for does not exist.",
          "isPartOf": {
            "@type": "WebSite",
            "@id": "https://coderide.ai/#website",
            "name": "CodeRide",
            "url": "https://coderide.ai/"
          },
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://coderide.ai/"
              },
              {
                "@type": "ListItem",
                "position": 2,
                "name": "404 Not Found"
              }
            ]
          }
        }}
      />
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href="/" className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
